import { useMemo } from 'react';

const useTicketInformationLogsColumns = () => {
    const columns = useMemo(
        () => [
            {
                key: 'ticketCode',
                title: 'Ticket Code',
                dataIndex: 'ticketCode',
            },
            {
                key: 'block',
                title: 'Block',
                dataIndex: 'block',
                render: record => (record ? 'Block' : 'Unblock'),
            },
            {
                key: 'commentByUser',
                title: 'Comment',
                dataIndex: 'commentByUser',
            },
        ],
        []
    );

    return columns;
};

export default useTicketInformationLogsColumns;
